import type { Theme } from '@mui/material';

export const styles = {
  dropdown: (theme: Theme) => ({
    flex: 1,
    height: '2.5rem',
    bgcolor: theme.colors.neutral[50],
    color: theme.colors.neutral[600],
    justifyContent: 'center',
    border: 'none',
    borderRadius: '0.375rem',

    '> fieldset': {
      border: 'none',
    },
    typography: theme.typography.body3,
    '& .MuiMenuItem-root': {
      ...theme.typography.body3,
    },
  }),

  selectMenu: (theme: Theme) => ({
    '& .MuiMenuItem-root': {
      ...theme.typography.body3,
    },
  }),

  pickerField: (theme: Theme) => ({
    width: '7.6rem',
    backgroundColor: theme.colors.neutral[50],
    borderRadius: '6px',
    border: `1px solid ${theme.colors.neutral[200]}`,

    '& .MuiInputAdornment-root': {
      display: 'none',
    },
    '& .MuiInputBase-root': {
      paddingRight: 0,
    },
    '& .MuiInputBase-input': {
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '18px',
    },
  }),

  error: (theme: Theme) => ({
    color: theme.colors.error[600],
  }),
};
